export default "__VITE_ASSET__2dae22c9__"